import { useEffect, useState } from "react";
import { getToken, storeToken } from "./storage";
import { Route, Routes } from "react-router-dom";
import { CarbonContext } from "./CarbonContext";
import Login from "./pages/Login";
import Registration from "./pages/Registration";
import Home from "./pages/Home";
import AllCars from "./pages/AllCars";
import Orders from "./pages/Orders";
import About from "./pages/About";
import NotFound from "./pages/NotFound";

function App() {
  const [token, setToken] = useState({});

  // Fetch Token From Local Storage
  useEffect(() => {
    getToken().then((token) => {
      if (!token) {
        return;
      }
      setToken(JSON.parse(token));
    });
  }, []);

  // Store Token Local Storage
  useEffect(() => {
    if (!token.access_token) return;
    storeToken(token);
  }, [token]);

  return (
    <CarbonContext.Provider value={{ token, setToken }}>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/registration" element={<Registration />} />
        <Route path="/home" element={<Home />} />
        <Route path="/cars" element={<AllCars />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/about" element={<About />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </CarbonContext.Provider>
  );
}

export default App;
